import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { generatePath, useHistory, useLocation } from 'react-router';
import { gqlUserMailTempPassword } from './graphql';
import { getRouteByName } from 'app/routes';
import Card from 'react-bootstrap/Card';
import { useHandleError } from 'shared-pages/services';
import { Button } from 'react-bootstrap';
import { toastSuccess } from 'shared-pages/utils/toasts';
import { useTranslation } from 'react-i18next';

export const ForgotPwPage = () => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const { handleGraphqlError } = useHandleError('newbatteriescollection');
  const [sendEmail] = useMutation(gqlUserMailTempPassword);
  console.log(location.pathname);
  const [email, setEmail] = useState('');

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = () => {
    sendEmail({ variables: { email: email } })
      .then((d) => {
        console.log(d.data);
        toastSuccess(() => (
          <div>
            {t('Ελέγξτε το ηλεκτρονικό ταχυδρομείο σας.')}
            <br />
            {t('Σας έχει αποστελεί mail με τον κωδικό πρόσβασης.')}
          </div>
        ));
        if (d.data.userMailTempPassword) {
          history.push({
            pathname: generatePath(getRouteByName('HomePage')),
          });
        }
      })
      .catch((error) => {
        handleGraphqlError('mutation-add', error);
      });
  };

  return (
    <Card bg="light" className="rounded-0">
      <Card.Header>
        <Card.Title className="m-0">{t('Επαναφορά Κωδικού Πρόσβασης')}</Card.Title>
      </Card.Header>
      <Card.Body>
        <div className="text-hdr-normal font-weight-bold mb-4 ms-3">
          {t('Γράψτε το email που έχετε δηλώσει στον λογαριασμό σας')} <br />{' '}
          {t('και θα σας σταλεί νέος κωδικός πρόσβασης')}
        </div>
        <label>{t('Διεύθυνση Email: ')}</label>
        <input
          className="form-control import"
          onChange={handleChange}
          type="email"
          value={email}
        />{' '}
        <br />
        <Button variant="primary" onClick={handleSubmit}>
          Αποστολή
        </Button>
      </Card.Body>
    </Card>
  );
};
